import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Composite/ContactForm/ContactForm.css';
import script from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Composite/ContactForm/ContactForm.ts';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Composite.ContactForm';
export {styles};
export {script};